module.exports = __webpack_public_path__ + "img/cow-run-2.b7df85ad.png";